var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3053",
    "data-name": "Rectangle 3053",
    width: 28,
    height: 28,
    transform: "translate(0 28) rotate(-90)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27551",
    "data-name": "Group 27551",
    clipPath: ""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37913",
    "data-name": "Path 37913",
    d: "M17.465,12.814a5.922,5.922,0,1,1,5.929-5.922A5.922,5.922,0,0,1,17.465,12.814Zm0-10.423a4.522,4.522,0,1,0,4.529,4.522,4.522,4.522,0,0,0-4.529-4.522Z",
    transform: "translate(-3.465 -0.291)",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37914",
    "data-name": "Path 37914",
    d: "M26.436,33.623h-3.3a.7.7,0,0,1,0-1.4h1.9V28.555a6.3,6.3,0,0,0-6.3-6.265H11.785a6.3,6.3,0,0,0-6.265,6.3v3.668H16.139a.7.7,0,1,1,0,1.4H4.12v-5.1a7.7,7.7,0,0,1,7.7-7.665h6.916a7.7,7.7,0,0,1,7.7,7.7Z",
    transform: "translate(-1.236 -6.267)",
    fill: "#979797"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.11a115e12fbcb6b8fd531781c573180c.svg";
export { ForwardRef as ReactComponent };